'use strict'

const moduleConfig = require('../utils/module-config')

module.exports = (arg) => {
  const send = moduleConfig(arg)

  return {
    gc: require('./gc')(send),
    stat: require('./stat')(send),
    version: require('./version')(send)
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/repo/index.js
// module id = 411
// module chunks = 0